import { toPng } from 'html-to-image';

export async function downloadPosterPng(node, filename, scale = 2) {
  if (!node) return;
  const dataUrl = await toPng(node, { pixelRatio: scale, cacheBust: true, backgroundColor: '#ffffff' });
  const a = document.createElement('a');
  a.href = dataUrl;
  a.download = filename.endsWith('.png') ? filename : `${filename}.png`;
  a.click();
}

export function printPoster(node, wIn, hIn) {
  if (!node) return;
  const styleId = 'poster-print-style';
  let st = document.getElementById(styleId);
  if (!st) { st = document.createElement('style'); st.id = styleId; document.head.appendChild(st); }
  st.innerHTML = `@media print { @page { size: ${wIn}in ${hIn}in; margin: 0; } }`;

  const existing = document.querySelector('.print-container');
  if (existing) existing.remove();
  const wrap = document.createElement('div');
  wrap.className = 'print-container';
  const clone = node.cloneNode(true);
  clone.style.transform = 'none';
  clone.style.boxShadow = 'none';
  clone.style.margin = '0';
  wrap.appendChild(clone);
  document.body.appendChild(wrap);
  const cleanup = () => { wrap.remove(); window.removeEventListener('afterprint', cleanup); };
  window.addEventListener('afterprint', cleanup);
  window.print();
  setTimeout(cleanup, 1500);
}
